
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LiquidacionesAdmin.css";
import API from "../api";

export default function LiquidacionesAdmin() {
  const navigate = useNavigate();

  const [liquidaciones, setLiquidaciones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [facturas, setFacturas] = useState([]);
  const [liquidacionSeleccionada, setLiquidacionSeleccionada] =
    useState(null);
  const [cargandoFacturas, setCargandoFacturas] = useState(false);
  const [procesandoLiquidacion, setProcesandoLiquidacion] =
    useState(null);

  // Obtener liquidaciones
  useEffect(() => {
    const obtenerLiquidaciones = async () => {
      try {
        const token = sessionStorage.getItem("token");

        const respuesta = await fetch(
  `${API}/liquidaciones-admin`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const datos = await respuesta.json();

        if (!respuesta.ok) {
          throw new Error(
            datos.error || "Error al obtener liquidaciones"
          );
        }

        setLiquidaciones(datos);
      } catch (err) {
        setError(err.message);
      } finally {
        setCargando(false);
      }
    };

    obtenerLiquidaciones();
  }, []);

  // Formato de moneda
  const formatoMoneda = (valor) => {
    return `Q${Number(valor).toFixed(2)}`;
  };

  // Consultar facturas de una liquidación
  const verFacturas = async (liquidacion) => {
    setLiquidacionSeleccionada(liquidacion);
    setFacturas([]);
    setCargandoFacturas(true);
    setError("");

    try {
      const token = sessionStorage.getItem("token");

      const respuesta = await fetch(
  `${API}/liquidaciones/${liquidacion.id_liquidacion}/comprobantes`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudieron consultar las facturas"
        );
      }

      setFacturas(datos);
    } catch (err) {
      setError(err.message);
    } finally {
      setCargandoFacturas(false);
    }
  };

  // Abrir imagen o PDF en una pestaña nueva
  const abrirFactura = async (factura) => {
    const nuevaVentana = window.open("", "_blank");

    if (!nuevaVentana) {
      alert("El navegador bloqueó la nueva pestaña.");
      return;
    }

    let urlTemporal = null;

    try {
      const token = sessionStorage.getItem("token");

      const respuesta = await fetch(
  `${API}/comprobantes/${factura.id_comprobante}/archivo`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!respuesta.ok) {
        const datos = await respuesta.json().catch(() => ({}));

        throw new Error(
          datos.error || "No se pudo abrir la factura"
        );
      }

      const archivo = await respuesta.blob();

      if (
        !["image/jpeg", "image/png", "application/pdf"].includes(
          archivo.type
        )
      ) {
        throw new Error("Tipo de archivo no permitido");
      }

      urlTemporal = URL.createObjectURL(archivo);
      nuevaVentana.location.href = urlTemporal;

      const urlParaLiberar = urlTemporal;

      setTimeout(() => {
        URL.revokeObjectURL(urlParaLiberar);
      }, 300000);

      urlTemporal = null;
    } catch (err) {
      if (urlTemporal) {
        URL.revokeObjectURL(urlTemporal);
      }

      nuevaVentana.close();
      alert(err.message);
    }
  };

  // Aprobar o rechazar liquidación
  const revisarLiquidacion = async (liquidacion, nuevoEstado) => {
    const accion =
      nuevoEstado === "Aprobada" ? "aprobar" : "rechazar";

    const confirmar = window.confirm(
      `¿Estás seguro de que deseas ${accion} la liquidación #${liquidacion.id_liquidacion}?`
    );

    if (!confirmar) return;

    setProcesandoLiquidacion(liquidacion.id_liquidacion);

    try {
      const token = sessionStorage.getItem("token");

      const respuesta = await fetch(
  `${API}/liquidaciones/${liquidacion.id_liquidacion}/estado`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            estado: nuevoEstado,
          }),
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudo actualizar la liquidación"
        );
      }

      setLiquidaciones((anteriores) =>
        anteriores.map((item) =>
          item.id_liquidacion === liquidacion.id_liquidacion
            ? { ...item, estado: nuevoEstado }
            : item
        )
      );

      alert(
        datos.message || "Liquidación actualizada correctamente"
      );
    } catch (err) {
      alert(err.message);
    } finally {
      setProcesandoLiquidacion(null);
    }
  };

  const claseEstado = (estado) => {
    const clases = {
      Pendiente: "liquidacion-pendiente",
      Aprobada: "liquidacion-aprobada",
      Rechazada: "liquidacion-rechazada",
    };

    return clases[estado] || "";
  };


return (
  <div className="liquidaciones-admin">

    <div className="liquidaciones-boton-superior">
      <button
        type="button"
        className="liquidaciones-volver-dashboard"
        onClick={() => navigate("/dashboard")}
      >
        ← Volver al Dashboard
      </button>
    </div>

    <h1>Revisión de liquidaciones</h1>


      <p>
        Control de gastos y comprobantes de viáticos de
        Transportes Figueroa.
      </p>

      {cargando && <p>Cargando liquidaciones...</p>}

      {error && (
        <p className="error-liquidaciones" role="alert">
          {error}
        </p>
      )}

      {!cargando && !error && liquidaciones.length === 0 && (
        <div className="liquidaciones-tabla-contenedor">
          <p>No hay liquidaciones registradas.</p>
        </div>
      )}

      <div
        className={`liquidaciones-distribucion ${
          liquidacionSeleccionada ? "con-panel-facturas" : ""
        }`}
      >
      {!cargando && !error && liquidaciones.length > 0 && (
        <div className="liquidaciones-tabla-contenedor">
          <table className="liquidaciones-tabla">
            <thead>
              <tr>
                <th>ID</th>
                <th>Conductor</th>
                <th>Ruta</th>
                <th>Vehículo</th>
                <th>Monto entregado</th>
                <th>Total gastado</th>
                <th>Diferencia</th>
                <th>Facturas</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {liquidaciones.map((l) => {
                const diferencia =
                  Number(l.monto_entregado) -
                  Number(l.total_gastado);

                return (
                  <tr key={l.id_liquidacion}>
                    <td>#{l.id_liquidacion}</td>

                    <td>{l.conductor}</td>

                    <td>
                      {l.origen} → {l.destino}
                    </td>

                    <td>{l.vehiculo}</td>

                    <td>
                      {formatoMoneda(l.monto_entregado)}
                    </td>

                    <td>
                      {formatoMoneda(l.total_gastado)}
                    </td>

                    <td>
                      <strong>
                        {formatoMoneda(diferencia)}
                      </strong>
                    </td>

                    <td>{l.cantidad_facturas}</td>

                    <td>
                      <span
                        className={`estado-liquidacion ${claseEstado(
                          l.estado
                        )}`}
                      >
                        {l.estado}
                      </span>
                    </td>

                    <td>
                      <div className="acciones-liquidacion">
                        <button
                          type="button"
                          className="boton-liquidacion boton-ver-facturas"
                          onClick={() => verFacturas(l)}
                        >
                          Ver facturas
                        </button>

                        {l.estado === "Pendiente" && (
                          <>
                            <button
                              type="button"
                              className="boton-liquidacion boton-aprobar-liquidacion"
                              disabled={
                                procesandoLiquidacion !== null ||
                                Number(l.cantidad_facturas) === 0
                              }
                              onClick={() =>
                                revisarLiquidacion(l, "Aprobada")
                              }
                            >
                              {procesandoLiquidacion ===
                              l.id_liquidacion
                                ? "Procesando..."
                                : "Aprobar"}
                            </button>

                            <button
                              type="button"
                              className="boton-liquidacion boton-rechazar-liquidacion"
                              disabled={
                                procesandoLiquidacion !== null ||
                                Number(l.cantidad_facturas) === 0
                              }
                              onClick={() =>
                                revisarLiquidacion(l, "Rechazada")
                              }
                            >
                              Rechazar
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Panel independiente de facturas */}
      {liquidacionSeleccionada && (
        <div className="panel-facturas">
          <h2>
            Facturas de la liquidación #
            {liquidacionSeleccionada.id_liquidacion}
          </h2>

          {cargandoFacturas ? (
            <p>Cargando facturas...</p>
          ) : facturas.length === 0 ? (
            <p>No hay facturas adjuntas.</p>
          ) : (
            <ul className="lista-facturas">
              {facturas.map((factura) => (
                <li
                  key={factura.id_comprobante}
                  className="item-factura"
                >
                  <span className="nombre-factura">
                    {factura.nombre_original} —{" "}
                    {factura.tipo_archivo}
                  </span>

                  <button
                    type="button"
                    className="boton-liquidacion boton-abrir-factura"
                    onClick={() => abrirFactura(factura)}
                  >
                    Abrir factura
                  </button>
                </li>
              ))}
            </ul>
          )}

          <button
            type="button"
            className="boton-liquidacion boton-ver-facturas"
            onClick={() => {
              setLiquidacionSeleccionada(null);
              setFacturas([]);
            }}
          >
            Cerrar facturas
          </button>
        </div>
      )}

      </div>
    </div>
  );
}